import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDatabase, ref, set, onValue } from 'firebase/database';

const AddAboutUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    mission: '',
    approach: '',
    team: '',
    impact: '',
    stats: [{ number: '', label: '' }]
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const db = getDatabase();
    const aboutRef = ref(db, 'about');

    const unsubscribe = onValue(aboutRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setFormData({
          mission: data.mission || '',
          approach: data.approach || '',
          team: data.team || '',
          impact: data.impact || '',
          stats: data.stats || [{ number: '', label: '' }]
        });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleStatChange = (index, e) => {
    const { name, value } = e.target;
    const updatedStats = [...formData.stats];
    updatedStats[index][name] = value;
    setFormData(prev => ({
      ...prev,
      stats: updatedStats
    }));
  };

  const addStatField = () => {
    setFormData(prev => ({
      ...prev,
      stats: [...prev.stats, { number: '', label: '' }]
    }));
  };

  const removeStatField = (index) => {
    if (formData.stats.length > 1) {
      const updatedStats = [...formData.stats];
      updatedStats.splice(index, 1);
      setFormData(prev => ({
        ...prev,
        stats: updatedStats
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccess(false);

try {
  const db = getDatabase();
  await set(ref(db, 'about'), formData);
  setSuccess(true);
  setTimeout(() => {
    setSuccess(false);
    // navigate('/about'); <-- Removed this line
  }, 2000);
} catch (error) {
  console.error('Error saving about data:', error);
} finally {
  setSubmitting(false);
}

  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <h1 className="admin-title">Edit About Us Page</h1>
      
      <form onSubmit={handleSubmit} className="about-form">
        <div className="form-section">
          <h2>Our Mission</h2>
          <textarea
            name="mission"
            value={formData.mission}
            onChange={handleChange}
            placeholder="Enter mission content (supports HTML)"
            rows="6"
            required
          />
        </div>

        <div className="form-section">
          <h2>Our Approach</h2>
          <textarea
            name="approach"
            value={formData.approach}
            onChange={handleChange}
            placeholder="Enter approach content (supports HTML)"
            rows="6"
            required
          />
        </div>

        <div className="form-section">
          <h2>Our Team</h2>
          <textarea
            name="team"
            value={formData.team}
            onChange={handleChange}
            placeholder="Enter team content (supports HTML)"
            rows="6"
            required
          />
        </div>

        <div className="form-section">
          <h2>Our Impact</h2>
          <textarea
            name="impact"
            value={formData.impact}
            onChange={handleChange}
            placeholder="Enter impact content (supports HTML)"
            rows="6"
            required
          />
        </div>

        <div className="form-section">
          <h2>Statistics</h2>
          {formData.stats.map((stat, index) => (
            <div key={index} className="stat-input-group">
              <input
                type="text"
                name="number"
                value={stat.number}
                onChange={(e) => handleStatChange(index, e)}
                placeholder="Number (e.g., 100+)"
                required
              />
              <input
                type="text"
                name="label"
                value={stat.label}
                onChange={(e) => handleStatChange(index, e)}
                placeholder="Label (e.g., Happy Clients)"
                required
              />
              {formData.stats.length > 1 && (
                <button 
                  type="button" 
                  className="remove-btn"
                  onClick={() => removeStatField(index)}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
          <button 
            type="button" 
            className="add-btn"
            onClick={addStatField}
          >
            Add Another Statistic
          </button>
        </div>

        <div className="form-actions">
          <button 
            type="submit" 
            className="submit-btn"
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'Save Changes'}
          </button>
          {success && <span className="success-message">Saved successfully!</span>}
        </div>
      </form>

      <style jsx>{`
        .admin-container {
          padding: 40px 20px;
          max-width: 1200px;
          margin: 0 auto;
          font-family: 'Poppins', sans-serif;
          color: #2c3e50;
        }

        .admin-title {
          font-size: 2.5rem;
          color: #023e8a;
          margin-bottom: 30px;
          text-align: center;
          position: relative;
        }

        .admin-title:after {
          content: '';
          display: block;
          width: 100px;
          height: 4px;
          background: linear-gradient(to right, #3498db, #9b59b6);
          margin: 15px auto 0;
          border-radius: 2px;
        }

        .about-form {
          background: white;
          border-radius: 15px;
          padding: 30px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }

        .form-section {
          margin-bottom: 30px;
        }

        .form-section h2 {
          color: #023e8a;
          margin-bottom: 15px;
          font-size: 1.5rem;
        }

        textarea {
          width: 100%;
          padding: 15px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-family: inherit;
          font-size: 1rem;
          resize: vertical;
          transition: border 0.3s ease;
        }

        textarea:focus {
          border-color: #3498db;
          outline: none;
          box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
        }

        .stat-input-group {
          display: flex;
          gap: 15px;
          margin-bottom: 15px;
          align-items: center;
        }

        .stat-input-group input {
          flex: 1;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 1rem;
        }

        .add-btn, .remove-btn {
          padding: 8px 15px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 0.9rem;
          transition: all 0.3s ease;
        }

        .add-btn {
          background: #2ecc71;
          color: white;
        }

        .add-btn:hover {
          background: #27ae60;
        }

        .remove-btn {
          background: #e74c3c;
          color: white;
        }

        .remove-btn:hover {
          background: #c0392b;
        }

        .form-actions {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-top: 30px;
        }

        .submit-btn {
          padding: 12px 30px;
          background: linear-gradient(to right, #3498db, #9b59b6);
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
        }

        .submit-btn:disabled {
          background: #95a5a6;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .success-message {
          color: #2ecc71;
          font-weight: 600;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
        }

        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #3498db;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .admin-title {
            font-size: 2rem;
          }

          .stat-input-group {
            flex-direction: column;
            gap: 10px;
          }

          .stat-input-group input {
            width: 100%;
          }

          .form-actions {
            flex-direction: column;
          }
        }

        @media (max-width: 480px) {
          .admin-title {
            font-size: 1.8rem;
          }

          .about-form {
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default AddAboutUs;